import { useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";
import ThumbsUpStar from "../../../../assets/svg/thumbsUpStar";

const SideScreenLLM = ({
	isOpen,
	handleClose,
	LLMContent = "",
	loading,
	handleNext,
	handlePrev,
	showPagination,
}: {
	isOpen: boolean;
	handleClose: () => void;
	LLMContent: any;
	loading: boolean;
	handleNext: () => void;
	handlePrev: () => void;
	showPagination: boolean;
}) => {
	// Split the content by text wrapped in **
	const contentParts = LLMContent.split(
		/(?=^#{1,6} |\n(?=|)|\n(?=-{7,})|(?<=\*\:))/m
	);

	const [visibleParts, setVisibleParts] = useState(15);

	const handleShowMore = () => {
		setVisibleParts((prev) => Math.min(prev + contentParts.length - prev, contentParts.length));
	};

	if (!isOpen) return null;
	const closeSideScreen = () => {
		handleClose();
		setVisibleParts(15);
	};
	return (
		<>
			<div
				className="offcanvas-backdrop fade show"
				onClick={closeSideScreen}
			></div>
			<div
				className="offcanvas offcanvas-end show w-55"
				tabIndex={-1}
				id="offcanvasExample"
				aria-labelledby="offcanvasExampleLabel"
			>
				<div className="offcanvas-header">
					<h5 className="offcanvas-title" id="offcanvasExampleLabel" style={{
						fontSize: '1.25rem',
						fontWeight: 'bold',
						marginLeft: '3rem',
						padding: '10px 0px'
					}}>
						ENHANCE WITH AI
					</h5>
					<button
						type="button"
						className="btn-close"
						data-bs-dismiss="offcanvas"
						aria-label="Close"
						onClick={closeSideScreen}
					></button>
				</div>
				<div className="offcanvas-body scroller">

					{loading ? (
						<div className="d-flex flex-column justify-content-center align-items-center h-100">
							<output
								className="d-flex justify-content-center align-items-center spinner-border"
							>
								<span className="visually-hidden">Loading...</span>
							</output>
						</div>
					) : LLMContent.trim() === "" ? ( // show content not available message if response is empty and not loading
						<div
							className="d-flex justify-content-center align-items-center"
							style={{ height: "100%" }}
						>
							<p>No Recommendations available at the moment.</p>
						</div>
					) : (
						<>
							<div className="d-flex justify-content-start align-items-center gap-2 mb-3" >
								<ThumbsUpStar width={35} height={50}/>
								<h5 style={{
									fontSize: "1.5rem",
									fontWeight: "bold",
									color: "#003C9E",
									marginTop: "0.5rem"
								}}>Recommendations</h5>
							</div>
							<div style={{ borderBottom: "1px solid #000" }} className="mx-5">

								
								<div className="card-text nignt">
									
									<ReactMarkdown
										remarkPlugins={[remarkBreaks, remarkGfm]}
										children={contentParts.slice(0, visibleParts).join("")}
										components={{
											li: ({ node, ...props }) => (
												<li style={{ marginBottom: "3%" }} {...props} />
											),
											p: ({ node, ...props }) => (
												<p className="card-text nignt" {...props} style={{
													fontFamily:"Roboto"
												}} />
											),
											table: ({ node, ...props }) => (
												<div className="table-container pb-4" style={{
													fontFamily:"Roboto"
												}}>
													<table className="table table-striped" {...props} />
												</div>
											),
											tr: ({ node, ...props }) => (
												<tr className="cursor-pointer" {...props} />
											),
											th: ({ node, ...props }) => (
												<th className="py-4" {...props} />
											),
											td: ({ node, ...props }) => (
												<td className="py-4" {...props} />
											),
										}}
									/>
								</div>
								{visibleParts < contentParts.length && (
									<div className="text-center">
										<button
											className="btn btn-link mt-3"
											onClick={handleShowMore}
										>
											Show More
										</button>
									</div>
								)}
								<br />
							</div>
							<br />
							<div className="d-flex justify-content-between mx-5">
								{showPagination && (
									<div className="mb-3">
										<button
											type="submit"	
											className="btn btn-light btn-rounded"
											onClick={handlePrev}
										>
											Previous
										</button>
									</div>
								)}

								{showPagination && (
									<div className="mb-3">
										<button
											type="submit"
											className="btn btn-light btn-rounded btn-rounded-next"
											onClick={handleNext}
										>
											Next
										</button>
									</div>
								)}
							</div>
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default SideScreenLLM;
